import { Alert, Flex, Form, Radio } from 'antd'
import React from 'react'
import { t } from 'i18next'
import { ReactTrixRTEInput } from 'react-trix-rte'
import { SafeHtml } from '../../Common/Common'

const TOOLBAR_ACTIONS = [
  'bold', 'italic', 'strike', 'link',
  'heading1', 'quote', 'bullet', 'number',
  'undo', 'redo'
]

function TrixField ({ value = '', onChange }) {
  const refuseFile = (event) => {
    event.preventDefault()
  }

  return (
    <ReactTrixRTEInput
      isRailsDirectUpload={false}
      toolbarActions={TOOLBAR_ACTIONS}
      defaultValue={value}
      onChange={(event) => onChange(event.target.value)}
      onFileAccepted={refuseFile}
    />
  )
}

export default function BoxAnnouncementTab ({ form, state }) {
  return (
    <Flex vertical>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: '1em' }}
        title={t('Admin.BoxForm.announcement.help')}
      />
      <Form.Item name="announcement_displayed" label={t('Admin.BoxForm.announcement.displayed')}>
        <Radio.Group
          options={[
            { value: true, label: t('Admin.BoxForm.announcement.displayedYes') },
            { value: false, label: t('Admin.BoxForm.announcement.displayedNo') }
          ]} />
      </Form.Item>
      <Form.Item name="announcement" label={t('Admin.BoxForm.announcement.content')}>
        {state === 'show'
          ? <SafeHtml as='div' html={form.getFieldValue('announcement')} />
          : <TrixField />}
      </Form.Item>
    </Flex>
  )
}
